import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { hamMenuRight } from "../../assets/components/svgs";
import {
  Bottom,
  BreadcumbsContainer,
  DynamicContainer,
  Location,
  MenuButton,
  MenuButtonContainer,
  BreadCrumbs,
  DynamicButtonContainer,
} from "./MenuStyles";
import urlPaths from "../../constants/top-menu-constants";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setURLPaths } from "../../app/appInitializeReducer";
import { useTheme } from "../../context/themeContext";
import { useTranslation } from "react-i18next";

type Props = {
  buttons?: JSX.Element;
  breadcrumbs?: JSX.Element;
  setSidebarIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarIsActive: boolean;
};

const MenuBottom = ({
  buttons,
  breadcrumbs,
  setSidebarIsActive,
  sidebarIsActive,
}: Props) => {
  const location = useLocation().pathname;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const storedURLPaths = useAppSelector(
    (state) => state.initialLoadData?.urlPaths
  );
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (storedURLPaths.length) {
      const pathname: any = storedURLPaths.filter(
        (path: any) => path.key === location
      );
      if (pathname.length) {
        if (pathname[0].label !== title) {
          setTitle(pathname[0].label);
        }
      }
    }
    if (!storedURLPaths.length && isLoading) {
      dispatch(setURLPaths(urlPaths));
      setIsLoading(false);
    }
  }, [storedURLPaths, location]);

  return (
    <Bottom>
      <MenuButtonContainer theme={useTheme().theme}>
        <MenuButton
          isActive={sidebarIsActive}
          onClick={() => setSidebarIsActive((state) => !state)}
        >
          {hamMenuRight}
          {t("T_MENU")}
        </MenuButton>
      </MenuButtonContainer>
      <div className="flex h-full w-full items-center overflow-hidden border-b-[1.7px] px-1 md:w-[97%] md:px-5">
        {breadcrumbs ? (
          <DynamicContainer>
            <BreadcumbsContainer>
              <Location role="withbread" theme={useTheme().theme}>
                {title}
              </Location>
              <BreadCrumbs role="breadcrumbs">{breadcrumbs}</BreadCrumbs>
            </BreadcumbsContainer>
            <DynamicButtonContainer role="buttons">
              {buttons}
            </DynamicButtonContainer>
          </DynamicContainer>
        ) : (
          <Location
            id="header-location"
            className="w-3/4 overflow-hidden text-ellipsis whitespace-nowrap md:w-1/2"
            role="nobread"
            theme={useTheme().theme}
          >
            <Link
              id="header-title-link"
              to={location}
              onClick={() => {
                navigate(location);
              }}
              className="hover:text-primary-600 text-xs transition duration-150 ease-in-out md:text-xl"
              data-te-toggle="tooltip"
              data-te-placement="bottom"
              title={title}
            >
              {title}
            </Link>
          </Location>
        )}
        <div
          id="header-bottom-right-container"
          className="flex flex-auto justify-end md:items-end"
        />
      </div>
    </Bottom>
  );
};

export default MenuBottom;
